import correct from '@/assets/img/documents/house-hold/protokol-szkody.jpg';
import wrong from '@/assets/img/documents/house-hold/protokol-szkody-wrong.jpg';

import Card from '@/components/Card';
import { Uploader } from '@/components/ui/Uploader/Uploader';
import { ATTACHMENT_TYPES } from '@/consts';

import { useLingui } from '@lingui/react';

export const DAMAGE_PROTOCOL_NAME = 'damage_protocol';

const DamageProtocol = () => {
  const { i18n } = useLingui();

  const instructionProps = {
    title: i18n.t('Jak poprawnie dodać protokół szkody?'),
    steps: [
      i18n.t('Upewnij się, że wszystkie dane nieruchomości są widoczne.'),
      i18n.t('Sprawdź, czy załączasz wszystkie strony.'),
      i18n.t('Jeśli przesyłasz zdjęcia – sprawdź, czy dokument jest czytelny.'),
      i18n.t('Jeśli plik jest zabezpieczony – dołącz hasło.'),
    ],
    correctImg: correct,
    wrongImg: wrong,
  };

  return (
    <Card>
      <Uploader
        title={i18n.t('Protokół szkody')}
        instructionProps={instructionProps}
        inputFieldName={DAMAGE_PROTOCOL_NAME}
        attachmentTypeId={ATTACHMENT_TYPES.PROTOKOL_SZKODY}
        data-testid={`${DAMAGE_PROTOCOL_NAME}-uploader`}
      />
    </Card>
  );
};

export default DamageProtocol;
